const restrictedProducts = {
    "personalised-gift-message": {
        message: "Personalised Gift Messages are only available to purchase with another product."
    },
    "luxury-gift-wrapping": {
        message: "Luxury Gift Boxes are only available to purchase with another product."
    }
};
async function initCartBlocker() {

    let checkoutCartButton = document.querySelector('.cart-drawer__footer button[type="submit"]');
    let blocker = document.getElementById('cartDrawerCheckoutBlocker');
    let checkbox = document.getElementById('checkout_terms_agree');

    if (!checkoutCartButton || !blocker) return;

let restrictedItem = null;

try {
    const cart = await fetch('/cart.js').then(r => r.json());

const normalProducts = cart.items.filter(item => !restrictedProducts[item.handle]);
const restrictedItems = cart.items.filter(item => restrictedProducts[item.handle]);

if (restrictedItems.length > 0 && normalProducts.length === 0) {
    restrictedItem = restrictedItems[0];
    restrictedItem.message = restrictedProducts[restrictedItem.handle].message;
}
} catch (e) {
    console.error(e);
}

    function updateBlocker() {

        // Block if the cart only contains the gift message
if (restrictedItem) {
    blocker.style.display = 'block';
    blocker.title = restrictedItem.message;
    return;
}

        // Existing Terms & Conditions behaviour
        if (checkbox) {
            blocker.style.display = checkbox.checked ? 'none' : 'block';
        } else {
            blocker.style.display = 'none';
        }
    }

    updateBlocker();
const existing = document.getElementById('gift-message-warning');

if (existing && !restrictedItem) {
    existing.remove();
}
    if (checkbox) {
        checkbox.onchange = updateBlocker;
    }

    blocker.onclick = function () {

        console.log("Blocker clicked");

if (restrictedItem) {

    let existing = document.getElementById('gift-message-warning');

    if (!existing) {

        const warning = document.createElement('div');
        warning.id = 'gift-message-warning';
        warning.innerHTML = '<strong>' + restrictedItem.message + '</strong>';

        warning.style.background = '#FFF4E5';
        warning.style.color = '#7A4B00';
        warning.style.border = '1px solid #F5C97A';
        warning.style.padding = '12px';
        warning.style.marginBottom = '15px';
        warning.style.fontSize = '14px';
        warning.style.lineHeight = '1.4';

        const footer = document.querySelector('.cart-drawer__footer');

        if (footer) {
            footer.insertBefore(warning, footer.firstChild);
        }
    }

    return;
}

        document.getElementById('cartCheckboxContainer').classList.add('highlightText');

        setTimeout(() => {
            document.getElementById('cartCheckboxContainer').classList.remove('highlightText');
        }, 5000);
    };
}


function copyLink() {
    event.preventDefault();
    var linkButton = document.getElementById("sharebutton");
    if(navigator.clipboard) {
        navigator.clipboard.writeText(linkButton.href);
        linkButton.innerHTML = "Link Copied";
        linkButton.classList.add("copied");
    }
}

function resetProductPage() {
    $("input.message-input-wrapper").each(function() {
        this.value = '';
        $(this).hide();
    });

    $("input.card-message").each(function() {
        this.value = '';
    });

    $(".upsell-checkbox input").each(function() {
        this.checked = false;
        upsellProducts = [];
    });

    $("#upsellTimeStamp").val($.now());
    $("#itemTimestamp").val($.now());

    $("quantity-selector.quantity-selector").show();

    document.dispatchEvent(new CustomEvent("cart:refresh"));
}

async function checkForUpsellProducts() {

    if(document.getElementById('upsellTimeStamp')) {
        var formData = {items: []}
        var timestamp = document.getElementById('upsellTimeStamp').value;
        for (let i = 0; i < upsellProducts.length; i++) {
            formData.items.push({
                'id': upsellProducts[i],
                'quantity': 1,
                'properties': {
                    '_timestamp': timestamp,
                    '_upsell': "true",
                    '_child': "true"
                }
            });
        }
        formData['sections'] = "main-cart,cart-drawer";

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/javascript'
            },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    return;
                }
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        addToCartBtn: this.addToCartButton
                    },
                    bubbles: true
                }));

                resetProductPage();

            })
            .catch((e) => {
                console.error(e);
                document.getElementById('stringConfigErrorMessage').innerHTML = document.getElementById('stringConfigError').getAttribute("data-message");
                document.getElementById('stringConfigError').classList.add('active');
            });

    }
}




function setUpFilterControls() {
    // kudos https://stackoverflow.com/questions/68644260/how-to-close-details-tag-when-other-is-open-or-a-click-is-made-outside-the-tag#answer-68644266
    var details = [...document.querySelectorAll('body.template-collection .facets-sidebar details')];
    document.addEventListener('click', function(e) {
      if (!details.some(f => f.contains(e.target))) {
        details.forEach(f => f.removeAttribute('open'));
      } else {
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
      }
    })
}
function closeAllFilterControls() {
    var details = [...document.querySelectorAll('body.template-collection .facets-sidebar details')];
    details.forEach(f => f.removeAttribute('open'));
}
setUpFilterControls();

document.addEventListener("DOMContentLoaded", function() {
    // if remove is clicked, then disable the checkout button so any child gift wrap products can be safely removed
    document.querySelectorAll('.minicart--remove').forEach((button) => {
      button.addEventListener('click', () => {
        let checkoutButton = document.querySelector('.cart-drawer__footer button[type="submit"]');
        if(checkoutButton !== null) {
            checkoutButton.setAttribute('disabled', 'disabled');
        }
      });
    });
});